var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('a',_vm._g({attrs:{"href":_vm.href,"target":"_blank"}},on),[_c('v-btn',{attrs:{"icon":"","text":"","x-small":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icons.link))])],1)],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.href))])])}
var staticRenderFns = []

export { render, staticRenderFns }